/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import useForm from '../../hooks/useForm';
import Form from '../Form';
import Modal, { ModalHeader } from '../Modal';

const Recruit = (props) => {
  const [fields] = useState([
    {
      key: "recruitTitle",
      title: "지원공고",
      className: "mb-10",
    },
    {
      key: "name",
      title: "지원자",
      className: "mb-10",
    },
    {
      title: "연락처",
      key: "mobile",
      className: "mb-10",
    },
    {
      title: "이메일",
      key: "email",
      className: "mb-10",
    },
    [
      {
        key: "resumeFile",
        title: "이력서",
        type: "file-upload",
        className: "mb-10",
      },
    ],
    [
      {
        key: "coverletterFile",
        title: "자소서",
        type: "file-upload",
        className: "mb-10",
      },
    ],
    [
      {
        key: "answer",
        title: "답변",
        className: "mb-10",
      },
    ],
  ]);

  const { open, setOpen, submit, selectedItem, setSelectedItem } = props;

  const cancel = (e) => {
    if (e) {
      e.preventDefault();
    }
    setOpen(false);
    setForm({});
    submit && submit();
    if (setSelectedItem) {
      setSelectedItem(null);
    }
  };

  const _submit = (form) => {
  };

  const {
    form,
    setForm,
    errors,
    setOriginForm,
  } = useForm(
    {},
    _submit,
  );

  useEffect(() => {
    if (selectedItem) {
      setForm(selectedItem);
      setOriginForm(selectedItem);
    } else {
      setForm({});
      setOriginForm({});
    }
  }, [open, selectedItem]);
  return (
    <>
      <Modal
        isOpen={open}
        close={cancel}
      >
        <ModalHeader>
          {``}
        </ModalHeader>
        <Form
          fields={fields}
          form={form}
          errors={errors}
          mode={"detail"}
          isRequiredShow={true}
          setForm={setForm}
          cancelText={"닫기"}
          cancel={cancel}
        />
      </Modal>
    </>
  );
};

export default Recruit;